import {
  Box,
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  fade,
  makeStyles,
} from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import React from 'react';

interface IProps {
  value: string;
  onChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  onClear: () => void;
  filled?: boolean;
}

const useStyles = makeStyles({
  filledInput: {
    backgroundColor: '#FFF',
  },
});

const TextSearchField: React.FC<IProps> = ({
  value,
  onChange,
  onClear,
  filled,
}) => {
  const { filledInput } = useStyles();
  return (
    <Box mx={1}>
      {filled ? (
        <FormControl className={filledInput} variant="filled" size="small">
          <InputLabel>Filter</InputLabel>
          <FilledInput
            classes={{ root: filledInput }}
            value={value}
            onChange={onChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end" size="small" onClick={onClear}>
                  <Clear fontSize="small" />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      ) : (
        <FormControl variant="outlined" size="small">
          <InputLabel>Filter</InputLabel>
          <OutlinedInput
            value={value}
            onChange={onChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton edge="end" size="small" onClick={onClear}>
                  <Clear fontSize="small" />
                </IconButton>
              </InputAdornment>
            }
            labelWidth={36}
          />
        </FormControl>
      )}
    </Box>
  );
};

export default TextSearchField;
